var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myBox", class: { noborder: _vm.noborder } },
    [
      _c("div", { staticClass: "mt-4" }, [
        _c("h2", { staticClass: "mb-1" }, [_vm._v("Zahlungsarten")]),
        _c(
          "div",
          {
            staticClass: "d-flex flex-wrap",
            staticStyle: { "max-width": "520px" },
          },
          [
            _vm.enableGoodpay
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/applepay.png"),
                  },
                })
              : _vm._e(),
            _vm.enableGoodpay
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/googlepay.png"),
                  },
                })
              : _vm._e(),
            _vm.enableGoodpay
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/visa.png"),
                  },
                })
              : _vm._e(),
            _vm.enableGoodpay
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/mastercard.png"),
                  },
                })
              : _vm._e(),
            _vm.enableGoodpay
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/discover.png"),
                  },
                })
              : _vm._e(),
            _vm.enablePaypal
              ? _c("v-img", {
                  attrs: {
                    contain: "",
                    width: "10%",
                    src: require("../assets/payment/paypal.png"),
                  },
                })
              : _vm._e(),
            _c("v-spacer"),
          ],
          1
        ),
        _c("div", { staticClass: "pt-4" }, [
          _c("h4", [
            _vm._v(_vm._s(_vm._f("stringList")(_vm.displayPaymentMethods))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }